<procure-card
  class="warning-card"
  condensed
  flat
  [class.no-margin]="noMargin()"
>
  @if (routerLink()) {
    <a
      class="message"
      [class.warning]="type() === 'warning'"
      [class.critical]="type() === 'critical'"
      [class.information]="type() === 'information'"
      [class.success]="type() === 'success'"
      [class.disclosure]="type() === 'disclosure'"
      [routerLink]="routerLink()"
    >
      <ng-container *ngTemplateOutlet="content" />
    </a>
  } @else {
    <div
      class="message"
      [class.warning]="type() === 'warning'"
      [class.critical]="type() === 'critical'"
      [class.information]="type() === 'information'"
      [class.success]="type() === 'success'"
      [class.disclosure]="type() === 'disclosure'"
    >
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }
</procure-card>

<ng-template #content>
  <mat-icon
    class="icon"
    aria-hidden="true"
    >{{ icon() }}</mat-icon
  >
  <div class="content">
    <ng-content />
  </div>
</ng-template>
